module.exports = __webpack_public_path__ + "img/clock-five-thirty.9e801742.svg";